import React from "react";
import { RiCloseLine } from "react-icons/ri";
import { useMiniSwingLibraryStore } from "../../../store/miniSwingLibraryStore";
import Filters from "./components/Filters";
import Table from "./components/Table";
import { Pagination } from "../../../../../../../components/shared/Pagination/Pagination";

const SwingLibraryMini = ({ onClose }) => {
  const { pagination, resetActiveFilters, resetPagination, setPagination } =
    useMiniSwingLibraryStore();

  const pageNumber = Math.max(1, pagination?.totalPages || 1);

  const handleClose = () => {
    resetPagination();
    resetActiveFilters();
    onClose();
  };

  return (
    <div className="border-gray200 flex size-full flex-col overflow-hidden rounded-2xl border bg-white shadow-2xl">
      <div className="border-gray200 flex items-center justify-between border-b px-3 py-2">
        <Filters />
        <RiCloseLine
          className="text-gray500 hover:text-gray800 size-6 cursor-pointer"
          onClick={handleClose}
        />
      </div>

      <div className="flex-1 overflow-y-auto">
        <Table />
      </div>

      {pageNumber > 1 && (
        <Pagination
          className="border-gray200 border-t p-2"
          currentPage={pagination.page}
          onPageChange={(page) => setPagination({ page })}
          pageNumber={pageNumber}
          rowsPerPage={pagination.rowsPerPage}
          showItemsPerPage={false}
          size="sm"
        />
      )}
    </div>
  );
};

export default SwingLibraryMini;
